<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    [ngStyle]="style"
    [class]="styleClass"
    [ngClass]="{
        'p-slider p-component':true,'p-disabled':disabled,
        'p-slider-horizontal':orientation == 'horizontal','p-slider-vertical':orientation == 'vertical','p-slider-animate':animate
    }"
    (click)="onBarClick($event)"
>
    <span
        *ngIf="range && orientation == 'horizontal'"
        class="p-slider-range"
        [ngStyle]="{'left':handleValues[0] + '%',width: (handleValues[1] - handleValues[0] + '%')}"
    ></span>
    <span
        *ngIf="range && orientation == 'vertical'"
        class="p-slider-range"
        [ngStyle]="{'bottom':handleValues[0] + '%',height: (handleValues[1] - handleValues[0] + '%')}"
    ></span>
    <span
        *ngIf="!range && orientation=='vertical'"
        class="p-slider-range"
        [ngStyle]="{'height': handleValue + '%'}"
    ></span>
    <span
        *ngIf="!range && orientation=='horizontal'"
        class="p-slider-range"
        [ngStyle]="{'width': handleValue + '%'}"
    ></span>
    <span
        #sliderHandle
        [id]="id + '_handle'"
        *ngIf="!range"
        [attr.tabindex]="disabled ? null : tabindex"
        (keydown)="onHandleKeydown($event)"
        class="p-slider-handle"
        (mousedown)="onMouseDown($event)"
        (touchstart)="onTouchStart($event)"
        (touchend)="onTouchEnd($event)"
        [style.transition]="dragging ? 'none': null"
        [ngStyle]="{'left': orientation == 'horizontal' ? handleValue + '%' : null,'bottom': orientation == 'vertical' ? handleValue + '%' : null}"
        role="slider"
        [attr.aria-valuemin]="min"
        [attr.aria-valuenow]="value"
        [attr.aria-valuemax]="max"
        [attr.aria-valuetext]="ariaValueText"
        [attr.aria-labelledby]="ariaLabelledBy"
    >
        <span
            *ngIf="showValue"
            class="agpr-sliderHandleLabel"
        >
            {{ value + '%'}}
        </span>
    </span>
    <span
        #sliderHandleStart
        *ngIf="range"
        [id]="id + '_range_start'"
        [attr.tabindex]="disabled ? null : tabindex"
        (keydown)="onHandleKeydown($event,0)"
        (mousedown)="onMouseDown($event,0)"
        (touchstart)="onTouchStart($event,0)"
        (touchmove)="onTouchMove($event,0)"
        (touchend)="onTouchEnd($event)"
        [style.transition]="dragging ? 'none': null"
        class="p-slider-handle"
        [ngStyle]="{'left': rangeStartLeft, 'bottom': rangeStartBottom}"
        [ngClass]="{'p-slider-handle-active':handleIndex==0}"
    ></span>
    <span
        #sliderHandleEnd
        *ngIf="range"
        [id]="id + '_range_end'"
        [attr.tabindex]="disabled ? null : tabindex"
        (keydown)="onHandleKeydown($event,1)"
        (mousedown)="onMouseDown($event,1)"
        (touchstart)="onTouchStart($event,1)"
        (touchmove)="onTouchMove($event,1)"
        (touchend)="onTouchEnd($event)"
        [style.transition]="dragging ? 'none': null"
        class="p-slider-handle"
        [ngStyle]="{'left': rangeEndLeft, 'bottom': rangeEndBottom}"
        [ngClass]="{'p-slider-handle-active':handleIndex==1}"
    ></span>
</div>
